import * as SentryApi from "@sentry/react";
import { center_app_version } from "../version";

class SentryConnection {
    public initSentry() {
        const { hostname } = window.location
        const environment = hostname.includes('.flytrex.com') ? 
          hostname.replace('.flytrex.com', '') : hostname
        const isLocalEnv = ['localhost', '127.0.0.1'].includes(hostname)

        // TODO: take env and sentry URL from env variables
        // From Sentry docs: 
        // DSNs are safe to keep public because they only allow submission of new events and related event data; they do not allow read access to any information."
        // While there is a risk of abusing a DSN, where any user can send events to your organization with any information they want, this is a rare occurrence.
        const sentryDsn = isLocalEnv ? 
          "https://1db48781df5b4e3483363794cee21c67@o1053150.ingest.sentry.io/4504836523425792" : // Yossi's personal test sentry project
          "https://b6321a9a5b70437ca6ee04f76a188f71@o361932.ingest.sentry.io/4504837134942208" // Flytrex "center-app" project
        SentryApi.init({
          environment,
          release: center_app_version.commit_sha,
          dsn: sentryDsn,
          debug: isLocalEnv
        })
    }

    public setUser(user: {id: number, email: string, name: string}) {
        SentryApi.setUser({
            id: user.id.toString(),
            email: user.email,
            name: user.name,
        })
    }

    // By default, sentry/react has instrumentation which reports unhandled exceptions to sentry, so this method should only be used when 
    // We want to report a handled exception.
    public reportError(error: Partial<Error>): void {
        const reportedError = error instanceof Error ? error : Error(error.message)
        if (error.stack) {
          reportedError.stack = error.stack
        }
        SentryApi.captureException(reportedError)
    }
}

export const SentryService = new SentryConnection()